<template>
     <vs-popup class="holamundo" title="Add New Tags" :active.sync="isPopupActiveLocal">
                    <div>
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                            <vs-input class="w-full" label="Tag Name" v-model="dataName" />
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <vs-textarea label="Description" v-model="dataDescription" />
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col w-full">
                            <vs-button class="mr-3 mb-2" @click="submitData">Submit</vs-button>
                            </div>
                        </div>
                    </div>
                </vs-popup>
</template>

<script>
export default {
  props: {
    isPopupActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      dataId: null,
      dataName: '',
      dataDescription: null      
    }
  },
  watch: {
    isPopupActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { id, name, description} = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataName = name
        this.dataDescription = description

        this.initValues()
      }
    }

  },
  computed: {
    isPopupActiveLocal: {
      get () {
        return this.isPopupActive
      },
      set (val) {
        if (!val) {
          this.$emit('closePopup')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataName && this.dataDescription > 0
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataName = ''
      this.dataDescription = null

    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            id: this.dataId,
            name: this.dataName,
            description: this.dataDescription

          }

          if (this.dataId !== null) {
            this.$store.dispatch('tags/updateTag', obj)
              .then(response => {
                this.$vs.notify({
                  title: 'Updated',
                  text: response.data.data,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'success'
                })
              })
              .catch(err => { 
                this.$vs.notify({
                  title: 'Failed',
                  text: err,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                }) 
                console.error(err) 
              })
          } else {
            delete obj.id
            //obj.popularity = 0
            this.$store.dispatch('tags/addTag', obj)
              .then(response => {
                this.$vs.notify({
                  title: 'Success',
                  text: `tag-${response.data.data[0].name} added suceesfully`,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'success'
                })
              })
              .catch(err => {
                this.$vs.notify({
                  title: 'Failed',
                  text: err,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                }) 
                console.error(err) 
              })
          }

          this.$emit('closePopup')
          this.initValues()  
        }
      })

    }

  }
    
}
</script>